import React from "react";
import ourStory from "../assets/video/ourStory.mp4";
import {Link} from "react-router-dom";
const OurStory = () => {
  return (
    <>
      <section className="ourStory_sec">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-12 col-sm-12 col-xs-12">
              <div className="video">
                <div className="video">
                  <video
                    id="vid"
                    width="100%"
                    height="400"
                    autoPlay
                    loop
                    muted
                    controls
                  >
                    <source src={ourStory} type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-xs-12 main_heading">
                <div className="ourStory_content">
                    <h2 className="wow fadeInUp title40">Our Story</h2>
                    <p className="wow fadeInUp m-top20">Owner David Bronshtein is a third generation jeweler. As a little boy growing up, he spent a lot of his time shadowing and helping at his father's shop.. David made his first piece of jewelry at the age of eleven, a bracelet made of aluminum and copper. At eighteen, he enrolled in G.I.A - Gemological Institute of America. He graduated from there as a Graduate Jeweler Gemologist. In 1997, David opened his own shop and DiaMonté Jewelers was born.</p>
                    <Link to="/our-story" className="learn_more">Learn More</Link>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OurStory;
